var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "33px",
    viewBox: "0 0 39 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/General/Profile Like") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.9148523,0.000760792036 C23.7811134,-0.0168619173 20.801897,1.4287518 18.7833333,3.94644106 C16.7773283,1.4115243 13.7899022,-0.0380730601 10.6518143,0.000760792036 C4.76897972,0.000760792036 0,5.00968782 0,11.1885124 C0,21.7769202 17.5945148,32.1156015 18.3078059,32.515164 C18.5956543,32.7171676 18.9710124,32.7171676 19.2588608,32.515164 C19.9721519,32.1156015 37.5666667,21.9267562 37.5666667,11.1885124 C37.5666667,8.22133622 36.4444252,5.37568781 34.4468225,3.27757738 C32.4492198,1.17946696 29.7398891,0.000760792036 26.9148523,0.000760792036 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Profile-2",
    transform: "translate(-204.000000, -1526.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-2.000000, 1503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Profile-Liked",
    transform: "translate(200.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.533333, 8.166667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Maroon",
    mask: "url(#mask-2)",
    fill: "#710D0D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.533333, -8.166667)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritedIcon);
export default __webpack_public_path__ + "static/media/favorited-icon.5087f26ab4f2c7a22307f22232d5052a.svg";
export { ForwardRef as ReactComponent };